import React, {useEffect} from "react";
import './Projects.css';
import Photo1 from './food ordering.png';
import Photo2 from './tic-tac-toe.png';
import Photo3 from './unit convertor.png'
import Photo4 from './newsclassifier.png'
import Photo5 from './TO DO LIST.png'
import Photo6 from './TIPP.png';
import jquery from 'jquery';

const Project=()=>{
  useEffect(()=>{
    jquery(document).ready(function(){
      function handleResponsiveLayout(){
        var windowWidth = jquery(window).width();
        if(windowWidth <=768){
          jquery('.card-main').removeClass('col-12').addClass('col-6');
        } else{
          jquery('.card-main').removeClass('col-6').addClass('col-12');
        }
      }
      handleResponsiveLayout();
      jquery(window).resize(function(){
        handleResponsiveLayout();
      });
    });
  },[]);
    return <>
    <div className="conatiner-fluid" id="project">
        <div className="project-container">
            <div className="heading">
                <h1 className="project_title">
                    Projects
                </h1>
                <p className="project_description no-gutters">
                Welcome to my portfolio, where I showcase my expertise in an array of technologies. From Python's Tkinter module for GUI-based applications to machine learning using algorithms like Naïve Bayes. I excel in web development with HTML, CSS, JavaScript, and React.js. Leveraging the power of the MERN stack, I create dynamic applications that bring ideas to life. Join me on this technological journey as we explore the endless possibilities together.
                </p>
            </div>
        <div className="row slide ">
            <div className="card-main col-6">
            <div className="imgbox">
             <img src={Photo6} alt="photo1"/>
            </div>
            <div class="content-card">
            <h2>TIPP</h2>
            <p>
            TIPP is an innovative Full Stack MERN-Based project that aims to revolutionize students' Technical Interview Preparation, offering them an exceptional learning experience. By providing them  quizes of the related subjects.
            </p>
            </div>
            </div>
            <div className="card-main col-6">
            <div className="imgbox">
             <img src={Photo5} alt="photo1"/>
            </div>
            <div class="content-card">
            <h2>TO DO LIST</h2>
            <p>
            The MERN Stack-based TODO LIST is a seamless and efficient application for managing tasks. With MongoDB handling data storage and Express.js, React.js, and Node.js powering the front-end and back-end, the app enables smooth CRUD operations. Users can easily add, update, and delete tasks, staying organized and productive with this user-friendly solution.
            </p>
            </div>
            </div>
        <div className="card-main col-6">
        <div className="imgbox">
             <img src={Photo2} alt="photo1"/>
        </div>
        <div class="content-card">
        <h2>TIC TAC TOE</h2>
        <p>
        The React.js based tic-tac-toe game is an interactive web application that offers an enjoyable gaming experience. With its responsive design and real-time updates, players can challenge friends or the computer, making every move exciting and fun.
        </p>
        </div>
        </div>
        <div className="card-main col-6">
        <div className="imgbox">
             <img src={Photo3} alt="photo1"/>
        </div>
        <div class="content-card">
        <h2>UNIT CONVERTOR</h2>
        <p>
        The Python Tkinter GUI-based unit converter is a user-friendly application for seamless unit conversion. With its intuitive interface and various conversion options, it simplifies the process of converting different units. Whether it's length, weight, or temperature, this tool provides accurate and efficient conversions for users of all levels.
        </p>
        </div>
        </div>
        <div className="card-main col-6">
        <div className="imgbox">
             <img src={Photo1} alt="photo1"/>
        </div>
        <div class="content-card">
        <h2>HTML FOOD ORDERING WEBSITE</h2>
        <p>
        The HTML-based food ordering website design that looks forward to offer a user-friendly platform with an intuitive menu and seamless order placement, making it a go-to destination for food enthusiasts.
        </p>
        </div>
        </div>
        <div className="card-main col-6">
        <div className="imgbox">
             <img src={Photo4} alt="photo1"/>
        </div>
        <div class="content-card">
        <h2>Naive Bayes Text Classifier</h2>
        <p>
        The 20 Newsgroups Naive Bayes text classifier is a powerful machine learning model for text classification. It efficiently categorizes documents into one of twenty different newsgroups based on their content, making it a popular choice for tasks like email filtering and sentiment analysis.
        </p>
        </div>
        </div>
        </div>
        </div>
        </div>
    </>
}
export default Project;